module.exports = __webpack_public_path__ + "static/media/token-dot.c3659820.svg";